import React, { memo } from 'react'
import './loader.scss'
import { LOADER } from 'utils/constants/index'
const Loader = ({ component }) => {
  switch (component) {
    case LOADER.CONTENT:
      return (
        <div className='d-flex justify-content-center mt-2 mb-2'>
          <div className='spinner-border text-light mt-2 mb-2' role='status'>
            <span className='sr-only'>Loading...</span>
          </div>
        </div>
      )

    case LOADER.TABLE_CELL:
      return <span className='spinner-border spinner-border-sm text-light' role='status' aria-hidden='true' />

    case LOADER.BUTTON:
      return <span className='spinner-border spinner-border-sm text-light' role='status' aria-hidden='true' />

    case LOADER.PAGE:
      return <div className='page-loader-container'>
        <div className='d-flex justify-content-center spinner-border show-loader text-light' role='status' />
      </div>

    default:
      return (
        <div className='d-flex justify-content-center spinner-border show-loader' role='status' />
      )
  }
}

export default memo(Loader)
